import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/tm'
  },
  {
    name: 'tm',
    component: () => import('./view/tm'),
    // meta: {
    //   title: 'aaaaaaa'
    // }
  },
  {
    name: 'browser',
    component: () => import('./view/tm/browser'),
  },
  {
    name: 'ai2',
    component: () => import('./view/tm/ai2'),
  },
  {
    name: 'soft',
    component: () => import('./view/tm/soft'),
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
